module.exports = __webpack_public_path__ + "static/img/Bachelor_010795.7759f3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010795.jpg
// module id = 250
// module chunks = 0